import { useDispatch } from "react-redux";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import GlobalButton from "../../../../components/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import CustomRangePicker from "../../../../components/DateRangePicker";
import { useSelector } from "react-redux";
import { MenuItem, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomSelect from "../../../../components/customSelect";
import TextInput from "../../../../components/TextInputs";
import { setInventoryMovementEndDate, setInventoryMovementSearchValue, setInventoryMovementStartDate, setInventoryMovementType } from "../../../../lib/slices/search_key_slice";
import { setInventoryCurrentPage } from "../../../../lib/slices/paginationSlice";
import { INVENTORY_MOVEMENT_REASON } from "../../../../constants/Variables";


export const Filters = ({ fetchData }) => {
    // dispatch actions
    const dispatch = useDispatch();

    // Tracking state
    const { t } = useTranslation();

    // Search keys
    const searchKeys = useSelector((state) => state.SearchKeysReducer.searchKeys);

    // Get current language
    const { currentLanguage } = useSelector((state) => state.translationReducer);

    // Get pagination data
    const pagination = useSelector((state) => state.paginationReducer);


    return (
        <Stack
            p={2}
            direction={{ xs: "column", md: "row" }}
            alignItems={"stretch"}
            gap={1.25}
            bgcolor={"primary.light"}
        >
            <TextInput
                styleProps={{
                    width: { xs: "100%", md: "34%", xl: "30%" },
                }}
                InputStartIcon={<SearchIcon />}
                InputEndIcon={
                    searchKeys.inventoryMovementSearchValue && (
                        <CancelOutlinedIcon
                            fontSize="small"
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                                dispatch(setInventoryMovementSearchValue(""));
                            }}
                        />
                    )
                }
                placeholder={t("common.searchBySku")}
                value={searchKeys.inventoryMovementSearchValue}
                onChange={(e) => {
                    dispatch(setInventoryMovementSearchValue(e.target.value));
                }}
            />
            <CustomSelect
                placeholder={t("common.reason")}
                formStyleProps={{
                    width: { xs: "100%", md: "30%", xl: "28%" },
                 
              
                }}
                value={searchKeys.inventoryMovementType}
                onChange={(e) => {
                    dispatch(setInventoryCurrentPage(1));
                    dispatch(setInventoryMovementType(e.target.value));
                }}
            >
                <MenuItem value={"All"}>{t("common.all")}</MenuItem>
                {INVENTORY_MOVEMENT_REASON.map((val, ind) => (
                    <MenuItem
                        key={ind}
                        value={val.value}
                        sx={{ textTransform: "capitalize" }}
                    >
                        {val.label[currentLanguage]}
                    </MenuItem>
                ))}
            </CustomSelect>

            <Stack
                direction={"row"}
                alignItems={"stretch"}
                sx={{
                    width: { xs: "100%", md: "36%", xl: "42%" },
                    minWidth: 0,
                }}
            >
                <CustomRangePicker
                    startDate={searchKeys.inventoryMovementStartDate}
                    setStartDate={(value) => {
                        // dispatch(setUserPlanCurrentPage(1));
                        dispatch(setInventoryMovementStartDate(value));
                    }}
                    endDate={searchKeys.inventoryMovementEndDate}
                    setEndDate={(value) => {
                        // dispatch(setUserPlanCurrentPage(1));
                        dispatch(setInventoryMovementEndDate(value));
                    }}
                    stackProps={{
                        flex: 1,
                        minWidth: 0,
                        height: 42,
                        px: 1.25,
                        borderRadius: "6px 0px 0px 6px",
                        border: "1px solid #dddddd",
                    }}
                    rangeProps={{
                        displayFormat: "DD MMM YYYY",
                    }}
                />
                <GlobalButton
                    endIcon={<SearchIcon />}
                    handleClickBtn={() => {
                        dispatch(setInventoryCurrentPage(1));

                        fetchData?.(
                            searchKeys.inventoryMovementSearchValue,
                            searchKeys.inventoryMovementType,
                            pagination.page,
                            pagination.limit,
                            searchKeys.inventoryMovementStartDate,
                            searchKeys.inventoryMovementEndDate,
                        );
                    }}
                    styleProps={{
                        color: "primary",
                        width: "auto",
                        borderRadius: "0px 6px 6px 0px",
                        minWidth: 45,
                        height: "42px",
                        "& .MuiButton-icon": {
                            marginLeft: "0px",
                        },
                    }}
                />
            </Stack>
        </Stack>
    );
};